// import {useMediaQuery} from '@material-ui/core';
// import ButtonBase from '@material-ui/core/ButtonBase';
// import Paper from '@material-ui/core/Paper';
// import {makeStyles} from '@material-ui/core/styles';
// import {Android} from '@material-ui/icons';
// import clsx from 'clsx';
// import React from 'react';
// import {useHistory} from 'react-router-dom';

// const useStyles = makeStyles((theme) => ({
//   fullWidth: {
//     width: '100%',
//     fontSize: 0,
//     // borderBottomRightRadius: 32,
//     // borderBottomLeftRadius: 32,
//     borderRadius: 15,
//     boxShadow: 'none',
//   },
//   fullHeight: {
//     height: '100%',
//     display: 'flex',
//     alignItems: 'center',
//   },
// }));

// export default React.memo(function ButtonImageBorderHome({src, alt, ...props}) {

//   const classes = useStyles();
//   const history = useHistory();
//   const isMobile = useMediaQuery('(max-width:1400px)');

//   return (
//     <ButtonBase
//       className={clsx(classes.fullWidth, classes.fullHeight)}
//       focusRipple
//       {...props}
//     >
//       <Paper className={clsx(classes.fullWidth, classes.fullHeight)}>
//         <img
//           // className={classes.fullWidth}
//           style={{
//             cursor: 'pointer',
//             marginTop: -20,
//             width: isMobile && !props?.android ? '90%' : '100%',
//             paddingBottom: isMobile && !props?.android ? '20px' : '',
//             display: 'block',
//             margin: '0 auto',
//             objectFit: 'cover',
//           }}
//           src={src}
//           alt={alt}
//           // onClick={() => {
//           //   history.push('/app/advisers?skill=28');
//           //   // history.push('/app/advisers', {
//           //   //   title: 'پزشکان و مشاوران آنلاین',
//           //   //   params: {
//           //   //     online: true,
//           //   //   },
//           //   // });
//           // }}
//         />
//       </Paper>
//     </ButtonBase>
//   );
// });
import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Autoplay, Pagination} from 'swiper/core';
// import {useMediaQuery} from '@material-ui/core';
import {useHistory} from 'react-router-dom/cjs/react-router-dom.min';

SwiperCore.use([Autoplay, Pagination]);
export default function ButtonImageBorderHome({banners, ...props}) {
  // const isMobile = useMediaQuery('(max-width:1400px)');
  const history = useHistory();
  return (
    // <Grid container>
    banners.length === 1 ? (
      <img
        style={{
          cursor: 'pointer',
          marginTop: -30,
          width: '100%',
          // paddingBottom: isMobile && !props?.android ? '20px' : '',
          display: 'block',
          margin: '0 auto',
          objectFit: 'cover',
        }}
        src={banners[0].link}
        alt={`banner`}
        onClick={() => {
          banners[0].url?.startsWith('http')
            ? (window.location.href = banners[0].url)
            : history.push(banners[0].url ?? banners[0].url);
        }}
      />
    ) : (
      <Swiper
        className="mySwiper"
        autoplay={{delay: 3000}}
        pagination={{clickable: true}}
        loop={true}
        lazy={true}
      >
        {banners?.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              loading="lazy"
              style={{
                cursor: 'pointer',
                marginTop: -30,
                width: '100%',
                display: 'block',
                margin: '0 auto',
                objectFit: 'cover',
              }}
              src={item?.link}
              alt={`banner-${index}`}
              onClick={() => {
                item.url?.startsWith('http')
                  ? (window.location.href = item.url)
                  : history.push(item.url);
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    )
    // </Grid>
  );
}
